import { render, staticRenderFns } from "./SystemDictionaryList.vue?vue&type=template&id=1c374ff3&scoped=true&"
import script from "./SystemDictionaryList.vue?vue&type=script&lang=js&"
export * from "./SystemDictionaryList.vue?vue&type=script&lang=js&"
import style0 from "./SystemDictionaryList.vue?vue&type=style&index=0&id=1c374ff3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c374ff3",
  null
  
)

export default component.exports